import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Modal, Btn } from '../common/AquaUI';
import { useTheme } from '../../context/ThemeContext';

export default function AquaLayout({ children, currentUser, onLogout, unreadAlertas, notification, showAlert, setShowAlert, navigate }) {
  const { theme, toggleTheme, isDarkMode } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(() => (
    typeof window !== 'undefined' ? window.innerWidth > 900 : true
  ));
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 900;

  return (
    <div className="app-container">
      <Sidebar currentUser={currentUser} onLogout={onLogout} unreadAlertas={unreadAlertas} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && isMobile && <button className="sidebar-backdrop" aria-label="Cerrar menú" onClick={() => setSidebarOpen(false)} />}

      {/* Main Content */}
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Topbar Monolítica */}
        <header className="topbar">
          <button className="sidebar-toggle" type="button" aria-label={sidebarOpen ? "Cerrar menú" : "Abrir menú"} onClick={() => setSidebarOpen(o => !o)}>
            <i className="ph ph-list"></i>
          </button>
          <div className="search-bar">
            <i className="ph ph-magnifying-glass"></i>
            <input type="text" placeholder="Buscar registros e información..." />
          </div>

          <div className="user-profile">
            <button
              onClick={toggleTheme}
              title={isDarkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
              style={{
                background: 'var(--bg-hover)',
                border: '1px solid var(--border-subtle)',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '1rem',
                color: 'var(--text-secondary)',
                marginRight: '1rem',
                padding: '6px 10px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <i className={`ph ${isDarkMode ? 'ph-sun' : 'ph-moon'}`}></i>
            </button>
            <i className="ph-fill ph-bell" style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', marginRight: '1rem', cursor: 'pointer' }} onClick={() => navigate("/alertas")}></i>
            <div className="user-info">
              <span className="user-name">{currentUser.nombre}</span>
              <span className="user-role">{currentUser.rol}</span>
            </div>
            <div className="avatar">
              {currentUser.nombre[0]}
            </div>
          </div>
        </header>

        {/* Notificación flotante vieja, ahora controlada por Sileo pero mantenida por si acaso */}
        {notification && (
          <div style={{
            position:"fixed", top:20, right:20, zIndex:2000,
            background: notification.type==="error" ? "#7f1d1d" : notification.type==="warning" ? "#78350f" : "#164e63",
            border:`1px solid ${notification.type==="error"?"#ef4444":notification.type==="warning"?"#f59e0b":"#06b6d4"}`,
            borderRadius:10, padding:"14px 20px", maxWidth:360,
            boxShadow:"0 8px 32px rgba(0,0,0,0.3)", fontSize:14, color:"#f1f5f9",
          }}>{notification.msg}</div>
        )}

        {/* Alerta modal operario */}
        {showAlert && currentUser.rol === "operario" && (
          <Modal title="⏰ Recordatorio de Registro" onClose={() => setShowAlert(false)} width={420}>
            <div style={{ textAlign:"center", padding:"20px 0" }}>
              <div style={{ fontSize:48, marginBottom:16 }}>⚠️</div>
              <p style={{ color: theme.subtext, marginBottom:24 }}>Es hora de registrar los parámetros de calidad del agua.</p>
              <div style={{ display:"flex", gap:12, justifyContent:"center" }}>
                <Btn color="green" onClick={() => { setShowAlert(false); navigate("/registros"); }}>Ir a Registrar</Btn>
                <Btn color="gray" onClick={() => setShowAlert(false)}>Recordar Luego</Btn>
              </div>
            </div>
          </Modal>
        )}

        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  );
}
